export default __webpack_public_path__ + "static/media/Montserrat-Light.6fcc9263.ttf";